exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".patients{padding:15px}.patients h2{margin-bottom:15px}.patients .patient{margin-bottom:15px;position:relative}.patients .patient a{color:inherit;text-decoration:none;cursor:pointer}.patients .patient .delete-button-icon{position:absolute;top:15px;right:15px;color:#e96f6f;cursor:pointer;font-size:1.5em}.patients .patient .delete-button-icon:hover{color:#f79494}.patients .subtitle{font-weight:400;color:#999}.patients .patients-empty{margin-top:24px;text-align:center;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/PatientList/PatientList.scss
// module id = 590
// module chunks = 0